import React, { useContext, useRef, useState } from "react";
import {
  CreateEditInstallment,
  CreateInstallment,
  PreviewInstallment,
} from "../../service/CustomerSupport";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import PDFViewerComponent from "./PDFViewerComponent";
import PaymentTable from "./PaymentTable";
import CommonButton from "../common/CommonButton";
import translations from "../common/Translations";

const isOnlyCustomerSupportTrue = (userObj) => {
  const permissionKeys = Object.keys(userObj).filter((key) =>
    key.startsWith("canAccess") || key.startsWith("canAdd") || key.startsWith("canModify") || key.startsWith("canCreate")
  );

  let trueCount = 0;

  for (let key of permissionKeys) {
    if (userObj[key] === true) {
      if (key !== "canAccessCustomerSupport") return false;
      trueCount++;
    } else if (userObj[key] === null || userObj[key] === false) {
      continue;
    } else {
      continue;
    }
  }

  return userObj.canAccessCustomerSupport === true && trueCount === 1;
};


const CreateInstallmentPlan = () => {
  const tableRef = useRef();
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  console.log('previewData: ', previewData);
  const [accountNo, setAccountNo] = useState("");
  const [customerID, setCustomerId] = useState();
  const [phone, setPhone] = useState("");
  const [numInstallments, setNumInstallments] = useState();
  const [advancePayment, setAdvancePayment] = useState();
  const [advanceDate, setAdvanceDate] = useState("");
  const [firstInstallmentDate, setFirstInstallmentDate] = useState("");
  const { userType, theme,  pdfData, langMode, user, projectId } =
  useContext(AppContext);
  const result = isOnlyCustomerSupportTrue(user);
  const [countryDetail, setCountryDetail] = useState([
    { name: "Afghanistan", length: 9, countryCode: "+93" },
    { name: "Albania", length: 8, countryCode: "+355" },
    { name: "Algeria", length: 9, countryCode: "+213" },
    { name: "Andorra", length: 6, countryCode: "+376" },
    { name: "Angola", length: 9, countryCode: "+244" },
    { name: "Argentina", length: 10, countryCode: "+54" },
    { name: "Armenia", length: 8, countryCode: "+374" },
    { name: "Aruba", length: 7, countryCode: "+297" },
    { name: "Australia", length: 9, countryCode: "+61" },
    { name: "Austria", length: 12, countryCode: "+43" },
    { name: "Azerbaijan", length: 9, countryCode: "+994" },
    { name: "Antigua and Barbuda", length: 7, countryCode: "+1268" },
    { name: "Bahamas", length: 7, countryCode: "+1 242" },
    { name: "Bahrain", length: 8, countryCode: "+973" },
    { name: "Bangladesh", length: 10, countryCode: "+880" },
    { name: "Barbados", length: 10, countryCode: "+1 246" },
    { name: "Belarus", length: 9, countryCode: "+375" },
    { name: "Belgium", length: 9, countryCode: "+32" },
    { name: "Belize", length: 7, countryCode: "+501" },
    { name: "Benin", length: 8, countryCode: "+229" },
    { name: "Bhutan", length: 8, countryCode: "+975" },
    { name: "Bolivia", length: 8, countryCode: "+591" },
    { name: "Bosnia and Herzegovina", length: 8, countryCode: "+387" },
    { name: "Botswana", length: 7, countryCode: "+267" },
    { name: "Brazil", length: 10, countryCode: "+55" },
    { name: "Brunei", length: 7, countryCode: "+673" },
    { name: "Bulgaria", length: 8, countryCode: "+359" },
    { name: "Burkina Faso", length: 10, countryCode: "+226" },
    { name: "Burundi", length: 8, countryCode: "+257" },
    { name: "British Indian Ocean Territiry", length: 7, countryCode: "+246" },
    { name: "Cabo Verde", length: 7, countryCode: "+238" },
    { name: "Cambodia", length: 9, countryCode: "+855" },
    { name: "Cameroon", length: 9, countryCode: "+237" },
    { name: "Canada", length: 11, countryCode: "+1" },
    { name: "Central African Republic", length: 10, countryCode: "+236" },
    { name: "Chad", length: 8, countryCode: "+235" },
    { name: "Chile", length: 9, countryCode: "+56" },
    { name: "China", length: 11, countryCode: "+86" },
    { name: "Colombia", length: 10, countryCode: "+57" },
    { name: "Comoros", length: 7, countryCode: "+269" },
    { name: "Congo (Congo-Brazzaville)", length: 10, countryCode: "+242" },
    { name: "Costa Rica", length: 8, countryCode: "+506" },
    { name: "Croatia", length: 9, countryCode: "+385" },
    { name: "Cuba", length: 8, countryCode: "+53" },
    { name: "Cyprus", length: 8, countryCode: "+357" },
    { name: "Czech Republic", length: 9, countryCode: "+420" },
    { name: "Denmark", length: 8, countryCode: "+45" },
    { name: "Djibouti", length: 7, countryCode: "+253" },
    { name: "Dominica", length: 10, countryCode: "+1 767" },
    { name: "Dominican Republic", length: 10, countryCode: "+1 809" },
    { name: "Ecuador", length: 9, countryCode: "+593" },
    { name: "Egypt", length: 10, countryCode: "+20" },
    { name: "El Salvador", length: 8, countryCode: "+503" },
    { name: "Equatorial Guinea", length: 9, countryCode: "+240" },
    { name: "Eritrea", length: 8, countryCode: "+291" },
    { name: "Estonia", length: 7, countryCode: "+372" },
    { name: "Eswatini", length: 8, countryCode: "+268" },
    { name: "Ethiopia", length: 9, countryCode: "+251" },
    { name: "Fiji", length: 7, countryCode: "+679" },
    { name: "Finland", length: 12, countryCode: "+358" },
    { name: "France", length: 9, countryCode: "+33" },
    { name: "Gabon", length: 8, countryCode: "+241" },
    { name: "Gambia", length: 7, countryCode: "+220" },
    { name: "Georgia", length: 9, countryCode: "+995" },
    { name: "Germany", length: 11, countryCode: "+49" },
    { name: "Ghana", length: 9, countryCode: "+233" },
    { name: "Greece", length: 10, countryCode: "+30" },
    { name: "Grenada", length: 10, countryCode: "+1 473" },
    { name: "Guatemala", length: 8, countryCode: "+502" },
    { name: "Guinea", length: 9, countryCode: "+224" },
    { name: "Guinea-Bissau", length: 7, countryCode: "+245" },
    { name: "Guyana", length: 10, countryCode: "+592" },
    { name: "Haiti", length: 8, countryCode: "+509" },
    { name: "Honduras", length: 8, countryCode: "+504" },
    { name: "Hungary", length: 9, countryCode: "+36" },
    { name: "Iceland", length: 7, countryCode: "+354" },
    { name: "India", length: 10, countryCode: "+91" },
    { name: "Indonesia", length: 10, countryCode: "+62" },
    { name: "Iran", length: 10, countryCode: "+98" },
    { name: "Iraq", length: 10, countryCode: "+964" },
    { name: "Ireland", length: 7, countryCode: "+353" },
    { name: "Israel", length: 9, countryCode: "+972" },
    { name: "Italy", length: 10, countryCode: "+39" },
    { name: "Jamaica", length: 10, countryCode: "+1 876" },
    { name: "Japan", length: 10, countryCode: "+81" },
    { name: "Jordan", length: 9, countryCode: "+962" },
    { name: "Kazakhstan", length: 10, countryCode: "+7" },
    { name: "Kenya", length: 10, countryCode: "+254" },
    { name: "Kiribati", length: 7, countryCode: "+686" },
    { name: "Kuwait", length: 8, countryCode: "+965" },
    { name: "Kyrgyzstan", length: 9, countryCode: "+996" },
    { name: "Laos", length: 8, countryCode: "+856" },
    { name: "Latvia", length: 8, countryCode: "+371" },
    { name: "Lebanon", length: 8, countryCode: "+961" },
    { name: "Lesotho", length: 8, countryCode: "+266" },
    { name: "Liberia", length: 7, countryCode: "+231" },
    { name: "Libya", length: 9, countryCode: "+218" },
    { name: "Liechtenstein", length: 10, countryCode: "+423" },
    { name: "Lithuania", length: 9, countryCode: "+370" },
    { name: "Luxembourg", length: 9, countryCode: "+352" },
    { name: "Madagascar", length: 9, countryCode: "+261" },
    { name: "Malawi", length: 10, countryCode: "+265" },
    { name: "Malaysia", length: 10, countryCode: "+60" },
    { name: "Maldives", length: 7, countryCode: "+960" },
    { name: "Mali", length: 8, countryCode: "+223" },
    { name: "Malta", length: 8, countryCode: "+356" },
    { name: "Marshall Islands", length: 7, countryCode: "+692" },
    { name: "Mauritania", length: 8, countryCode: "+222" },
    { name: "Mauritius", length: 10, countryCode: "+230" },
    { name: "Mexico", length: 10, countryCode: "+52" },
    { name: "Micronesia", length: 7, countryCode: "+691" },
    { name: "Moldova", length: 8, countryCode: "+373" },
    { name: "Monaco", length: 8, countryCode: "+377" },
    { name: "Mongolia", length: 8, countryCode: "+976" },
    { name: "Montenegro", length: 8, countryCode: "+382" },
    { name: "Morocco", length: 10, countryCode: "+212" },
    { name: "Mozambique", length: 9, countryCode: "+258" },
    { name: "Myanmar (formerly Burma)", length: 9, countryCode: "+95" },
    { name: "Namibia", length: 9, countryCode: "+264" },
    { name: "Nauru", length: 7, countryCode: "+674" },
    { name: "Nepal", length: 10, countryCode: "+977" },
    { name: "Netherlands", length: 10, countryCode: "+31" },
    { name: "New Zealand", length: 9, countryCode: "+64" },
    { name: "Nicaragua", length: 8, countryCode: "+505" },
    { name: "Niger", length: 8, countryCode: "+227" },
    { name: "Nigeria", length: 10, countryCode: "+234" },
    { name: "North Korea", length: 9, countryCode: "+850" },
    { name: "North Macedonia", length: 8, countryCode: "+389" },
    { name: "Norway", length: 8, countryCode: "+47" },
    { name: "Oman", length: 8, countryCode: "+968" },
    { name: "Pakistan", length: 10, countryCode: "+92" },
    { name: "Palau", length: 7, countryCode: "+680" },
    { name: "Palestine", length: 10, countryCode: "+970" },
    { name: "Panama", length: 7, countryCode: "+507" },
    { name: "Papua New Guinea", length: 10, countryCode: "+675" },
    { name: "Paraguay", length: 9, countryCode: "+595" },
    { name: "Peru", length: 9, countryCode: "+51" },
    { name: "Philippines", length: 10, countryCode: "+63" },
    { name: "Poland", length: 9, countryCode: "+48" },
    { name: "Portugal", length: 9, countryCode: "+351" },
    { name: "Qatar", length: 8, countryCode: "+974" },
    { name: "Romania", length: 10, countryCode: "+40" },
    { name: "Russia", length: 10, countryCode: "+7" },
    { name: "Rwanda", length: 10, countryCode: "+250" },
    { name: "Saint Kitts and Nevis", length: 10, countryCode: "+1 869" },
    { name: "Saint Lucia", length: 10, countryCode: "+1 758" },
    {
      name: "Saint Vincent and the Grenadines",
      length: 10,
      countryCode: "+1 784",
    },
    { name: "Samoa", length: 7, countryCode: "+685" },
    { name: "San Marino", length: 10, countryCode: "+378" },
    { name: "Sao Tome and Principe", length: 7, countryCode: "+239" },
    { name: "Saudi Arabia", length: 9, countryCode: "+966" },
    { name: "Senegal", length: 9, countryCode: "+221" },
    { name: "Serbia", length: 8, countryCode: "+381" },
    { name: "Seychelles", length: 7, countryCode: "+248" },
    { name: "Sierra Leone", length: 8, countryCode: "+232" },
    { name: "Singapore", length: 8, countryCode: "+65" },
    { name: "Slovakia", length: 9, countryCode: "+421" },
    { name: "Slovenia", length: 8, countryCode: "+386" },
    { name: "Solomon Islands", length: 7, countryCode: "+677" },
    { name: "Somalia", length: 8, countryCode: "+252" },
    { name: "South Africa", length: 10, countryCode: "+27" },
    { name: "South Korea", length: 10, countryCode: "+82" },
    { name: "South Sudan", length: 9, countryCode: "+211" },
    { name: "Spain", length: 9, countryCode: "+34" },
    { name: "Sri Lanka", length: 10, countryCode: "+94" },
    { name: "Sudan", length: 9, countryCode: "+249" },
    { name: "Suriname", length: 7, countryCode: "+597" },
    { name: "Sweden", length: 10, countryCode: "+46" },
    { name: "Switzerland", length: 9, countryCode: "+41" },
    { name: "Syria", length: 9, countryCode: "+963" },
    { name: "Taiwan", length: 9, countryCode: "+886" },
    { name: "Tajikistan", length: 9, countryCode: "+992" },
    { name: "Tanzania", length: 10, countryCode: "+255" },
    { name: "Thailand", length: 9, countryCode: "+66" },
    { name: "Timor-Leste", length: 9, countryCode: "+670" },
    { name: "Togo", length: 8, countryCode: "+228" },
    { name: "Tonga", length: 7, countryCode: "+676" },
    { name: "Trinidad and Tobago", length: 10, countryCode: "+1 868" },
    { name: "Tunisia", length: 8, countryCode: "+216" },
    { name: "Turkey", length: 10, countryCode: "+90" },
    { name: "Turkmenistan", length: 8, countryCode: "+993" },
    { name: "Tuvalu", length: 7, countryCode: "+688" },
    { name: "Uganda", length: 10, countryCode: "+256" },
    { name: "Ukraine", length: 9, countryCode: "+380" },
    { name: "United Arab Emirates", length: 9, countryCode: "+971" },
    { name: "United Kingdom", length: 10, countryCode: "+44" },
    { name: "United States", length: 10, countryCode: "+1" },
    { name: "Uruguay", length: 8, countryCode: "+598" },
    { name: "Uzbekistan", length: 9, countryCode: "+998" },
    { name: "Vanuatu", length: 7, countryCode: "+678" },
    { name: "Vatican City", length: 10, countryCode: "+379" },
    { name: "Venezuela", length: 10, countryCode: "+58" },
    { name: "Vietnam", length: 10, countryCode: "+84" },
    { name: "Yemen", length: 9, countryCode: "+967" },
    { name: "Zambia", length: 10, countryCode: "+260" },
    { name: "Zimbabwe", length: 9, countryCode: "+263" },
  ]);
  const [phoneError, setPhoneError] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [isEdit, setIsEdit, isEditing] = useState(false);

  const [isSaveChanges, setIsSaveChanges] = useState(false);

  const [newData, setNewData] = useState([]);


  const outstandingAmount = parseFloat(previewData?.outstandingAfterAdvance) || 0;
  const totalEMIAmount = previewData?.instalments.reduce((sum, inst) => sum + (parseFloat(inst.paymentAmount) || 0), 0);
  const isEMIMismatch = Math.abs(outstandingAmount - totalEMIAmount) > 0.01;

  const validatePhoneNumber = (phone) => {
    let numericPhone = phone.replace(/[^0-9]/g, "");
    const defaultCountry = { name: "Oman", length: 8, countryCode: "968" };

    let country = countryDetail.find((c) =>
      numericPhone.startsWith(c.countryCode.replace(/[^0-9]/g, ""))
    );

    if (!country) {
      country = defaultCountry;
      numericPhone = defaultCountry.countryCode + numericPhone;
    }

    if (country.countryCode === "+1") {
      if (
        countryDetail.name === "United States" &&
        numericPhone.length !== 11
      ) {
        setPhoneError(
          "United States phone numbers should be exactly 10 digits long."
        );
        return false;
      } else if (
        countryDetail.name === "Canada" &&
        numericPhone.length !== 12
      ) {
        setPhoneError("Canada phone numbers should be exactly 11 digits long.");
        return false;
      }
    } else {
      const phoneNumberLength =
        numericPhone.length - country.countryCode.replace(/[^0-9]/g, "").length;

      if (phoneNumberLength !== country.length) {
        setPhoneError(
          `${country.name} phone numbers should be exactly ${country.length} digits long.`
        );
        return false;
      }
    }

    setPhoneError("");
    return true;
  };
  const handlePreviewClick = async () => {
    let isToast;
    try {
      const response = await PreviewInstallment(

          accountNo, advancePayment, firstInstallmentDate, numInstallments, ((localStorage.getItem("projectId") || "").replace(/"/g, ""))

      );
      if (response?.header?.code === 600) {
        setPreviewData(response.body.value);
        // setIsPreviewVisible(true)
        isToast = "sent";
        toast.success(response.body.value || "Preview generated successfully");
      } else {
        isToast = "sent";
        toast.error(response.body.value);
      }
    } catch (error) {
      if (!isToast) {
        toast.error("Something went wrong!");
      }
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    const pdfBlob = await fetch(pdfUrl).then(res => res.blob()); // Convert URL to Blob
    const pdfFile = new File([pdfBlob], "installment_plan.pdf", { type: "application/pdf" }); // Convert Blob to File

    console.log("IsEdit Value: ", isEdit);
    if (isEdit) {
      const instalmentData = {
        projectId: ((localStorage.getItem("projectId") || "").replace(/"/g, "")),
        accountNo: accountNo,
        civilId: customerID,
        phoneNo: `968${phone}`,
        noOfInstalments: numInstallments,
        advanceAmount: advancePayment,
        advancePaymentDate: advanceDate,
        firstInstalmentDate: firstInstallmentDate,
      };
      formData.append("instalmentData", JSON.stringify(instalmentData));
      formData.append("pdfFile", pdfFile); // Append the File instead of a URL
      formData.append("instalmentDetails", JSON.stringify(newData));
      try {
        const response = await CreateEditInstallment(formData);

        if (response?.header?.code === 600) {
          setIsEdit(false);
          toast.success("Installment Plan Created Successfully!");
          setAccountNo("");
          setPhone("");
          setAdvanceDate("");
          setAdvancePayment("");
          setCustomerId("");
          setFirstInstallmentDate("");
          setNumInstallments("");
          setPreviewData(null);
        } else {
          toast.error(
            `Failed to create installment plan! Error Code: ${response?.header?.code || "Unknown"
            }`
          );
        }
      } catch (error) {
        toast.error("Error creating installment plan!");
        console.error(error);
      }
    } else {
      formData.append("projectId", ((localStorage.getItem("projectId") || "").replace(/"/g, "")));
      formData.append("accountNo", accountNo);
      formData.append("civilId", customerID);
      formData.append("phoneNo",  `968${phone}`);
      formData.append("noOfInstalments", numInstallments);
      formData.append("advanceAmount", advancePayment);
      formData.append("advancePaymentDate", advanceDate);
      formData.append("firstInstalmentDate", firstInstallmentDate);
      formData.append("pdf", pdfFile); // Append the File instead of a URL
      try {
        const response = await CreateInstallment(formData);

        if (response?.header?.code === 600) {
          toast.success("Installment Plan Created Successfully!");
          setAccountNo("");
          setPhone("");
          setAdvanceDate("");
          setAdvancePayment("");
          setCustomerId("");
          setFirstInstallmentDate("");
          setNumInstallments("");
          setPreviewData(null);
        } else {
          toast.error(
            `Failed to create installment plan! Error Code: ${response?.header?.code || "Unknown"
            }`
          );
        }
      } catch (error) {
        toast.error("Error creating installment plan!");
        console.error(error);
      }
    }
  };

  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<style>body{font-family:sans-serif;padding:20px;} table{width:100%;border-collapse:collapse;} th,td{border:1px solid #ccc;padding:8px;text-align:center;}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };


  const formatPhoneNumber = (value) => {
    console.log("value",value)
    const cleaned = value.replace(/\D/g, "").slice(0, 8);

    if (cleaned.length === 0) return ""; // <-- fix to allow clearing
  
    const match = cleaned.match(/^(\d{0,4})(\d{0,4})$/);
    if (!match) return "";
  
    const [, part1, part2] = match;
    return `${part1}${part2 ? " " + part2 : ""}`;
  };

  return (
    <div className="sm:w-full w-[90%] max-w-4xl mx-auto sm:p-6 p-3">
      <div className="mb-6">
        <label className="text-sm font-semibold">{translations[langMode].custDetail}</label>
      </div>
      <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-4 mb-6">
        <input
          type="number"
          value={accountNo}
          onChange={(e) => setAccountNo(e.target.value)}
          placeholder={translations[langMode].accno}
          className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
        />
        <input
          type="text"
          value={customerID}
          onChange={(e) => setCustomerId(e.target.value)}
          placeholder={translations[langMode].CustomerId}
          className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
        />

        <div>
          <div className="flex items-center rounded-[6px] w-full bg-white py-[5px] px-[10px] border border-[#D1D5DB] text-sm">
            <div className="flex items-center gap-2">
              <span>🇴🇲</span>
              <span className="font-bold">+968</span>
            </div>
            <input
              className={`block p-2 w-full text-sm text-gray-900 bg-transparent rounded-md
                            appearance-none border-0 focus:ring-0 focus:!shadow-none peer ${theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }`}
              type="tel"
              name="phone"
              value={phone}
              onChange={(e) => {
                const raw = e.target.value;
                const cleaned = raw.replace(/\D/g, "");
                const formatted = formatPhoneNumber(cleaned);
                setPhone(formatted)
              }}
              placeholder="9123 4567"
              maxLength={9}
            />
          </div>
          {phoneError && (
            <div className="text-xs" style={{ color: "red", marginTop: "2px" }}>
              {phoneError}
            </div>
          )}
        </div>
      </div>

      {/* Installment Details Section */}
      <div className="mb-6">
        <label className="text-sm font-semibold">{translations[langMode].instalDetail}</label>
      </div>
      <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-4 mb-6">

        <div className="flex flex-col gap-1">
        <input
          type="number"
          value={numInstallments}
          onChange={(e) => setNumInstallments(e.target.value)}
          placeholder={translations[langMode].NoOfinstallment}
          className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
        />
        {userType === "office_user" && result && (numInstallments && numInstallments.length > 6) && (
          <span className="text-red-500 text-sm">
            Can't add more than six digits in Installments
          </span>
        )}
        </div>
        <div>
        <input
          type="number"
          value={advancePayment}
          onChange={(e) => setAdvancePayment(e.target.value)}
          placeholder={translations[langMode].advancepayamt}
          className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
        />
        </div>
        <div className="flex flex-col h-auto">
          <label className="text-sm font-semibold mb-1 ml-2">
            {translations[langMode].advDate}
          </label>
          <input
            type="datetime-local"
            // value={advanceDate}
            // onChange={(e) => setAdvanceDate(e.target.value)}
            value={advanceDate.slice(0, 16)} // Ensure format remains valid
            onChange={(e) => {
              const selectedDate = e.target.value + ":00"; // Append seconds manually
              setAdvanceDate(selectedDate);
            }}
            placeholder={translations[langMode].advDate}
            className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-semibold mb-1 ml-2">
          {translations[langMode].firstInstDate}
          </label>
          <input
            type="datetime-local"
            value={firstInstallmentDate.slice(0, 16)} // Ensure format remains valid
            onChange={(e) => {
              const selectedDate = e.target.value + ":00"; // Append seconds manually
              setFirstInstallmentDate(selectedDate);
            }}
            placeholder={translations[langMode].firstInstDate}
            className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 w-full text-sm"
          />
        </div>
      </div>

      {/* Buttons Section */}
      <div className="flex flex-wrap justify-between mt-4 gap-2">
        <div className="flex gap-4">
          <CommonButton onClick={() => setPreviewData(null)} variant="danger" className="whitespace-nowrap">
            {translations[langMode].clrPreview}
          </CommonButton>

          <CommonButton onClick={handlePreviewClick} variant="primary" className="whitespace-nowrap">
            {translations[langMode].prevPlan}
          </CommonButton>
        </div>
        <CommonButton onClick={handlePrint} variant="primary" className="pointer-events-auto" disabled={!previewData}>
          Print
        </CommonButton>

      </div>

      {/* Create Installment Plan Button */}
      {previewData &&
        <div ref={tableRef}>
          <PaymentTable pevData={previewData} setIsEdit={setIsEdit} isEdit={isEdit} setNewData={setNewData} newData={newData} isSaveChanges={isSaveChanges} setIsSaveChanges={setIsSaveChanges} />
        </div>}
    
      <CommonButton
        onClick={handleSubmit}
        className={`create-plan mt-6 ${(!previewData || isEMIMismatch || isEditing || isSaveChanges || totalEMIAmount < 0) ? "cursor-not-allowed !bg-blue-300 hover:bg-blue-300" : ""}`}
        disabled={!previewData || isEMIMismatch || isEditing || isSaveChanges || totalEMIAmount < 0}
      >
          {translations[langMode].createInstallment}
      </CommonButton>


      {isPreviewVisible && pdfData && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
          <PDFViewerComponent
            data={previewData}
            onClose={() => setIsPreviewVisible(false)}
            setPdfUrl={setPdfUrl}
          />
        </div>
      )}
    </div>
  );
};

export default CreateInstallmentPlan;
